import React from 'react';
import { Clock, Heart, AlertCircle } from 'lucide-react';
export function PainSection() {
  return <section className="pt-4 pb-10 bg-white px-4 sm:px-6 lg:px-8" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        {/* Visual story card */}
        <div className="relative bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 mb-8 overflow-hidden shadow-xl" data-id="element-94">
          {/* Decorative blur */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-rose-600/20 rounded-full blur-3xl" aria-hidden="true" data-id="element-95" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-purple-600/10 rounded-full blur-2xl" aria-hidden="true" data-id="element-96" />

          <div className="relative" data-id="element-97">
            <div className="flex items-center gap-2 mb-5" data-id="element-98">
              <Clock className="h-4 w-4 text-rose-400" data-id="element-99" />
              <span className="text-rose-400 font-bold uppercase tracking-widest text-xs" data-id="element-100">
                6:00 PM — Cada día
              </span>
            </div>

            <p className="text-white text-xl md:text-2xl font-medium leading-relaxed mb-6 italic" data-id="element-101">
              "Llegas a casa después de un día eterno. Te sientas en el sofá
              <span className="text-rose-300" data-id="element-102"> 'solo un minuto'</span>... y ahí
              es donde muere tu intención de moverte."
            </p>

            <div className="border-t border-white/10 pt-5 flex items-start gap-3" data-id="element-103">
              <Heart className="h-5 w-5 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-104" />
              <p className="text-slate-300 text-base leading-relaxed" data-id="element-105">
                Ese peso en el pecho no es cansancio físico — es la{' '}
                <span className="text-white font-semibold" data-id="element-106">
                  decepción de fallarte a ti misma
                </span>{' '}
                una vez más.
              </p>
            </div>
          </div>
        </div>

        {/* ¿Te suena familiar? label */}
        <div className="flex items-center gap-2 mb-6" data-id="element-107">
          <AlertCircle className="h-4 w-4 text-rose-500" data-id="element-108" />
          <span className="text-rose-600 font-bold uppercase tracking-wide text-xs" data-id="element-109">
            ¿Te suena familiar?
          </span>
        </div>

        <div className="prose prose-slate mx-auto" data-id="element-110">
          <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-111">
            Deja de castigarte. Tu cerebro solo está tratando de "salvarte" (de
            la forma equivocada).
          </h2>

          <p data-id="element-112">
            Si eres una mujer que lleva el mundo en los hombros, tu carga mental
            es triple. Familia, trabajo, responsabilidades sin fin... Tu cerebro
            está en modo <strong data-id="element-113">"supervivencia"</strong>.
          </p>

          <p data-id="element-114">
            Cuando piensas en hacer ejercicio, tu mente lo ve como un gasto de
            energía peligroso y activa la flojera para protegerte. La motivación
            es un lujo que no tienes tiempo de esperar.
          </p>

          <div className="my-6 p-5 bg-rose-50 rounded-xl" data-id="element-115">
            <h4 className="font-bold text-rose-900 mb-1" data-id="element-116">
              La verdad dolorosa:
            </h4>
            <p className="text-rose-800 m-0" data-id="element-117">
              Estás cansada de pagar el gimnasio y solo ir a donar tu dinero. No
              necesitas más motivación, necesitas un sistema que funcione
              incluso cuando no tienes ganas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}